import React from "react";
import { ArrowRight, Truck, Clock, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Ground Handling",
  description: "Professional ramp services, cargo management, and technical support ensuring maximum speed and efficiency for every flight at N’djili International.",
  icon: Truck,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591502/img/ground_handling.png",
  link: "/ServicesPage",
  action: "Explore Services"
}, {
  title: "Crew Transport",
  description: "Elite logistics for flight crews and passengers, providing seamless transfers and high-standard hotel coordination with 24/7 reliability.",
  icon: Clock,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591502/img/crew_transport.png",
  link: "/ContactPage",
  action: "Book Transport"
}, {
  title: "Aircraft Charter",
  description: "Strategic charter solutions for cargo and private aviation, backed by our deep expertise in regional logistics and landing permit coordination.",
  icon: MapPin,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591502/img/cargo_aircraft.png",
  link: "/ContactPage",
  action: "Request Quote"
}];
export default function FleetSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="5499" id="strategic-aviation-solutions" ref={ref} className="bg-background py-24 relative overflow-hidden dark">
      <div className="container mx-auto px-4">
        <div className={`mb-16 text-center transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-6xl font-sans font-extrabold uppercase tracking-tighter text-foreground mb-4">
            Strategic <span className="text-primary">Aviation</span> Solutions
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-medium leading-relaxed">
            Your reliable partner for premium aviation logistics and ground handling services across the DR Congo.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          {services.map((service, i) => <div key={i} data-index={i} className={`group h-full transition-all duration-700 delay-[${i * 150}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Card className="relative h-[500px] flex flex-col justify-end overflow-hidden border-2 border-primary/30 hover:border-primary transition-all duration-500 rounded-none bg-black shadow-2xl">
                {}
                <div className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 group-hover:scale-110" style={{
              backgroundImage: `url(${service.image})`
            }} />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent opacity-90 transition-opacity duration-500 group-hover:opacity-95" />

                {}
                <div className="relative z-10 flex flex-col h-full justify-end p-0">
                  <CardHeader className="pb-2 px-8 pt-8">
                    <div className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-none bg-primary text-primary-foreground shadow-[0_0_20px_rgba(234,179,8,0.3)]">
                      <service.icon className="h-7 w-7" />
                    </div>
                    <CardTitle className="text-3xl font-sans font-bold uppercase tracking-tight text-white group-hover:text-primary transition-colors duration-300">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="px-8 pb-6">
                    <CardDescription className="text-gray-300 text-base font-medium leading-relaxed line-clamp-3 group-hover:text-white transition-colors duration-300">
                      {service.description}
                    </CardDescription>
                  </CardContent>

                  <CardFooter className="px-8 pb-8 pt-2">
                    <Button asChild className="w-full border border-primary/50 bg-transparent text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-500 font-bold uppercase tracking-widest h-14 rounded-none">
                      <Link to={service.link}>
                        {service.action}
                        <ArrowRight className="ml-2 h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
                      </Link>
                    </Button>
                  </CardFooter>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}